const callbacks: (() => void)[] = []

export default function useUpdate() {
  const camera = useCamera()
  const renderer = useRenderer()

  function update() {
    callbacks.forEach((callback) => callback())

    camera.update()
    renderer.update()
    // First we need to render, then update points
    // (otherwise there is a weird lag effect and points are on old frame position)
    // raycaster.update()
  }

  function addCallback(callback: () => void) {
    callbacks.push(callback)
  }

  return {
    update,
    addCallback,
  }
}
